import React, { useEffect, useState } from "react";
import "./Wwp.css";
import Hrline from "../../Hrline";
import Loader from "../../Gallery/components/Loader";

const API_URL = "https://api.nepalhouse.org";

const Wwp = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_URL}/api/categories`);
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const getImageUrl = (image) => {
    let imageUrl = image || "";
    imageUrl = imageUrl.replace(/\\/g, "/");

    if (!imageUrl.startsWith("/")) {
      imageUrl = `/${imageUrl}`;
    }

    return `${API_URL}/api${imageUrl}`;
  };

  const homepageCategories = categories.slice(0, 7);

  return (
    <div className="main-wwp-div">
      <Hrline />

      <div className="container wwp-block">
        <div className="text-center pt-4 Wwp-title">
          <h2 className="Wwp-h2">
            What We <span className="span-1">Provide?</span>
          </h2>
          <p className="Wwp-sub-title">
            Experience our exceptional services and quality products.
          </p>
        </div>

        <div className="row items-outer-div justify-content-between">
          {loading ? (
            <div className="d-flex justify-content-center w-100 my-5">
              <Loader />
            </div>
          ) : (
            <>
              {homepageCategories.map((item) => {
                const imageUrl = getImageUrl(item.image);

                return (
                  <div className="col-md-3 col-sm-6 col-12" key={item.id}>
                    <div className="cardwwp items-info text-center card-wwp">
                      <div className="img-div-Wwp">
                        <img
                          src={imageUrl}
                          alt={item.name}
                          className="items-img"
                          onError={(e) => {
                            console.error("Image failed to load:", e.target.src);
                            e.target.style.display = "none";
                          }}
                        />
                      </div>

                      <div className="items-brief">
                        <div className="items-brief-inner">
                          <h2 className="items-h2">{item.name}</h2>
                          <h4 className="items-h4">{item.sub_text}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {categories.length > 7 && (
                <div className="col-md-3 col-sm-6 col-12">
                  <div
                    className="cardwwp items-info text-center card-wwp view-all-wwp-card"
                    onClick={() => setShowPopup(true)}
                  >
                    <div className="view-all-wwp-content">
                      <div className="view-all-wwp-icon">+</div>
                      <h2>View All</h2>
                      <p>Explore all products and services</p>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        <div className="text-center buttons-kolom">
          <a
            href="https://nepalhouse.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="button-Wwp">
              <span className="Wwp-span">Shop Now</span>
            </button>
          </a>
        </div>
      </div>

      {showPopup && (
        <div className="wwp-popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="wwp-popup-box" onClick={(e) => e.stopPropagation()}>
            <button
              className="wwp-popup-close"
              onClick={() => setShowPopup(false)}
            >
              ×
            </button>

            <div className="wwp-popup-header">
              <h2>
                All <span>Categories</span>
              </h2>
              <p>Explore everything Nepal House provides.</p>
            </div>

            <div className="wwp-popup-grid">
              {categories.map((item) => {
                const imageUrl = getImageUrl(item.image);

                return (
             <div className="wwp-popup-card" key={item.id}>
  <div className="wwp-popup-img-div">
    <img
      src={imageUrl}
      alt={item.name}
      className="wwp-popup-img"
      onError={(e) => {
        e.target.style.display = "none";
      }}
    />
  </div>

  <h3>{item.name}</h3>

  {(item.sub_text || item.description) && (
    <p className="wwp-popup-description">
      {item.sub_text || item.description}
    </p>
  )}
</div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Wwp;